var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardiconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23702 3.24993C8.44303 1.97629 9.54603 1.33947 10.7522 1.27959C10.9174 1.27139 11.0829 1.27139 11.2481 1.27959C12.4543 1.33947 13.5573 1.97629 15.7633 3.24993C17.9693 4.52358 19.0723 5.1604 19.7273 6.17504C19.817 6.314 19.8997 6.45732 19.9752 6.60448C20.5264 7.67901 20.5264 8.95265 20.5264 11.4999C20.5264 14.0472 20.5264 15.3209 19.9752 16.3954C19.8997 16.5425 19.817 16.6859 19.7273 16.8248C19.0723 17.8395 17.9693 18.4763 15.7633 19.7499C13.5573 21.0236 12.4543 21.6604 11.2481 21.7203C11.0829 21.7285 10.9174 21.7285 10.7522 21.7203C9.54603 21.6604 8.44303 21.0236 6.23702 19.7499C4.03101 18.4763 2.928 17.8395 2.27305 16.8248C2.18335 16.6859 2.1006 16.5425 2.02511 16.3954C1.47388 15.3209 1.47388 14.0472 1.47388 11.4999C1.47388 8.95265 1.47388 7.67901 2.02511 6.60448C2.1006 6.45732 2.18335 6.314 2.27305 6.17504C2.928 5.1604 4.03101 4.52358 6.23702 3.24993Z",
    stroke: "#FF5A26",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0161 10.6038C9.21917 10.1107 9.61079 9.71905 10.104 9.51598L12.7808 8.41374C13.6028 8.07529 14.4247 8.89723 14.0863 9.71917L12.984 12.396C12.7809 12.8892 12.3893 13.2808 11.8962 13.4839L9.21928 14.5861C8.39735 14.9246 7.57541 14.1026 7.91386 13.2807L9.0161 10.6038Z",
    stroke: "#FF5A26",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardiconActive);
export default __webpack_public_path__ + "static/media/dashboardiconActive.792ad2c96e8fc8acb732925100f034a0.svg";
export { ForwardRef as ReactComponent };